import React from 'react';
import { useTranslation } from 'react-i18next';

export default function CookiesUse() {
  const { t } = useTranslation();
  const whatIsParagraphs = t('info.cookiesPage.whatIsParagraphs', {
    returnObjects: true,
  });
  const categories = t('info.cookiesPage.categories', { returnObjects: true });
  const sections = t('info.cookiesPage.sections', { returnObjects: true });
  const optionsParagraphs = t('info.cookiesPage.optionsParagraphs', {
    returnObjects: true,
  });

  return (
    <div className="container">
      <h1>{t('info.cookiesPage.title')}</h1>
      <h2>{t('info.cookiesPage.introTitle')}</h2>
      <p>{t('info.cookiesPage.introParagraph')}</p>

      <h2>{t('info.cookiesPage.whatIsTitle')}</h2>
      {whatIsParagraphs.map((paragraph, idx) => (
        <p key={`what-is-${idx}`}>{paragraph}</p>
      ))}

      <h2>{t('info.cookiesPage.howTitle')}</h2>
      <p>{t('info.cookiesPage.categoriesIntro')}</p>
      <ul>
        {categories.map((item, idx) => (
          <li key={`category-${idx}`}>{item}</li>
        ))}
      </ul>

      <h2>{t('info.cookiesPage.whatDoTitle')}</h2>
      {Object.entries(sections).map(([key, section]) => (
        <div key={key}>
          <h3>{section.title}</h3>
          <ul>
            {section.items.map((item, idx) => (
              <li key={`${key}-item-${idx}`}>{item}</li>
            ))}
          </ul>
        </div>
      ))}

      <h2>{t('info.cookiesPage.whereTitle')}</h2>
      <p>{t('info.cookiesPage.whereParagraph')}</p>

      <h2>{t('info.cookiesPage.optionsTitle')}</h2>
      <p>{t('info.cookiesPage.optionsIntro')}</p>
      {optionsParagraphs.map((paragraph, idx) => (
        <p key={`options-${idx}`}>{paragraph}</p>
      ))}

      <p>
        {t('info.cookiesPage.effectiveDate')}
        <br />
        {t('info.cookiesPage.lastUpdated')}
      </p>
    </div>
  );
}
